import React from 'react'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { IconBox, type IconName } from '@/components/frontend/atoms/content/IconBox'
import { Heading } from '@/components/frontend/atoms/typography/Heading'
import { Text } from '@/components/frontend/atoms/typography/Text'

interface FeatureItemProps {
  icon: IconName
  title: string
  description: string
}

export const FeatureItem: React.FC<FeatureItemProps> = ({ icon, title, description }) => (
  <Stack gap="3">
    <IconBox icon={icon} size="sm" />
    <Heading level="4" as="h3">{title}</Heading>
    <Text size="sm" tone="muted">{description}</Text>
  </Stack>
)
